/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IProductsDimensionsAvailabilities } from '@msdyn365-commerce/commerce-entities';
import MsDyn365, {
    getCatalogId,
    IComponent,
    IComponentProps,
    ICoreContext,
    IGridSettings,
    IImageData,
    IImageProps,
    IImageSettings,
    Image,
    IRequestContext,
    msdyn365Commerce,
    getUrlSync
} from '@msdyn365-commerce/core';
import {
    // AttributeSwatch,
    // ProductDimension,
    ProductPrice,
    ProductSearchResult,
    ProductType,
    SimpleProduct
} from '@msdyn365-commerce/retail-proxy';
import {
    // ArrayExtensions,
    // checkIfShouldDisplayAsSwatch,
    // convertDimensionTypeToProductDimensionType,
    // Dictionary,
    // DimensionSwatchDisplayTypes,
    // DimensionTypes,
    // generateImageUrl,
    getProductPageUrlSync
    // IDimensionsApp,
    // StringExtensions,
    // validateCatalogId
} from '@msdyn365-commerce-modules/retail-actions';
import {
    format,
    getPayloadObject,
    getTelemetryAttributes,
    ITelemetryContent,
    onTelemetryClick
} from '@msdyn365-commerce-modules/utilities';
import React from 'react';
// import {useState} from 'react';

import { getCartState } from '@msdyn365-commerce/global-state';

import {
    IPriceComponentResources,
    PriceComponent,
    AddToCartBehavior
    // ISwatchItem,
    // RatingComponent,
    // ProductComponentSwatchComponent
} from '@msdyn365-commerce/components';
import { IPopupProps, Popup } from '../../utilities/popup';
import { getEstimatedAvailabilityAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import {
    trackAddToCartFromListing,
    trackProductTileClick
} from '../../utilities/datalayer/index';

interface ProductComponentResources {
    addToCartText: string;
}

export interface IProductComponentProps extends IComponentProps<{ product?: ProductSearchResult }> {
    className?: string;
    imageSettings?: IImageSettings;
    savingsText?: string;
    freePriceText?: string;
    originalPriceText?: string;
    currentPriceText?: string;
    ratingAriaLabel?: string;
    ratingCountAriaLabel?: string;
    allowBack?: boolean;
    telemetryContent?: ITelemetryContent;
    quickViewButton?: React.ReactNode;
    productComparisonButton?: React.ReactNode;
    inventoryLabel?: string;
    isPriceMinMaxEnabled?: boolean;
    priceResources?: IPriceComponentResources;
    dimensionAvailabilities?: IProductsDimensionsAvailabilities[];
    swatchItemAriaLabel?: string;
    productCategoryUserPath?: string;
    productListName?: string;
    resources?: ProductComponentResources;
}

export interface IProductComponent extends IComponent<IProductComponentProps> {}

const PriceComponentActions = {};

// /**
//  * Renders product comparison button similar to the quick view button.
//  * @param productComparisonButton - React element of the button.
//  * @param product - Current product info.
//  * @param catalogId - Current catalog.
//  * @returns React element for the specific product.
//  */
// function renderProductComparisonButton(
//     productComparisonButton: React.ReactNode,
//     product: ProductSearchResult,
//     catalogId: number
// ): JSX.Element | undefined {
//     validateCatalogId(catalogId);
//     return React.cloneElement(productComparisonButton as React.ReactElement, { product, catalogId });
// }

const ProductCard: React.FC<IProductComponentProps> = ({
    data,
    context,
    imageSettings,
    savingsText,
    freePriceText,
    originalPriceText,
    currentPriceText,
    ratingAriaLabel,
    // ratingCountAriaLabel,
    allowBack,
    typeName,
    id,
    telemetryContent,
    // quickViewButton,
    // productComparisonButton,
    // inventoryLabel,
    isPriceMinMaxEnabled,
    priceResources,
    // dimensionAvailabilities,
    // swatchItemAriaLabel
    productCategoryUserPath,
    productListName,
    resources
}) => {
    const product = data.product;
    // const dimensionContext = context as ICoreContext<IDimensionsApp>;
    // const dimensionToPreSelectInProductCard = dimensionContext.app.config.dimensionToPreSelectInProductCard;

    if (!product) {
        return null;
    }

    //P&M DETAILS AND MODAL

    const valuemin = 0;
    const valuemax = 1000;

    // MODAL
    const [modalOpen, setModalOpen] = React.useState(false);

    const popupProps: IPopupProps = {
        context: context,
        className: 'msc-add-to-pmcart',
        id: id,
        typeName: typeName,
        data: { product: product, price: product.Price },
        // @ts-ignore
        dialogStrings: {},
        imageSettings: imageSettings,
        gridSettings: context.request.gridSettings,
        productQuantity: 1,
        navigationUrl: '',
        modalOpen: modalOpen,
        setModalOpen: setModalOpen
    };

    const renderModalPopup = <Popup {...popupProps} />;

    const catPage = context.request.urlTokens.categories !== undefined ? context.request.urlTokens.categories[0] : '';

    //FINISHP&M

    //AVAILABILITY
    const [available, setAvailable] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [availableLabel, setAvailableLabel] = React.useState('Available');
    const _isAvailable = async () => {
        await getEstimatedAvailabilityAsync(
            { callerContext: context.actionContext },
            { ProductIds: [product.RecordId], DefaultWarehouseOnly: true, QuantityUnitTypeValue: 2 }
        )
            .then(productAvailabilites => {
                if (
                    productAvailabilites &&
                    productAvailabilites.ProductWarehouseInventoryAvailabilities &&
                    productAvailabilites.ProductWarehouseInventoryAvailabilities?.length > 0
                ) {
                    if (product.ItemId !== '99991') {
                        if (
                            (productAvailabilites.ProductWarehouseInventoryAvailabilities[0].MaximumPurchasablePhysicalAvailableQuantity ||
                                0) <= 0
                        ) {
                            setAvailable(false);
                            setLoading(false);
                            setAvailableLabel(
                                productAvailabilites.ProductWarehouseInventoryAvailabilities[0].PhysicalAvailableInventoryLevelLabel ||
                                    'OUT OF STOCK'
                            );
                        } else if (
                            (productAvailabilites.ProductWarehouseInventoryAvailabilities[0].MaximumPurchasablePhysicalAvailableQuantity ||
                                0) >= 1
                        ) {
                            setAvailable(true);
                            setLoading(false);
                        } else if (
                            (productAvailabilites.ProductWarehouseInventoryAvailabilities[0].MaximumPurchasablePhysicalAvailableQuantity ||
                                0) > 0 &&
                            (productAvailabilites.ProductWarehouseInventoryAvailabilities[0].MaximumPurchasablePhysicalAvailableQuantity ||
                                0) < 1
                        ) {
                            // To cover the scenario where Maximum[...]Quantity is 0.5 or so
                            setAvailable(false);
                            setLoading(false);
                            // Without this it would say "Available", which it technically is but it also can't be bought
                            //TODO move in resources
                            switch (context.request.locale) {
                                case 'it':
                                    setAvailableLabel('NON DISPONIBILE');
                                    break;
                                case 'en-GB':
                                    setAvailableLabel('OUT OF STOCK');
                                    break;
                                case 'en-US':
                                    setAvailableLabel('OUT OF STOCK');
                                    break;
                                case 'de':
                                    setAvailableLabel('NICHT VERFÜGBAR');
                                    break;
                                case 'fr':
                                    setAvailableLabel('NON DISPONIBLE');
                                    break;
                                default:
                                    setAvailableLabel('OUT OF STOCK');
                                    break;
                            }
                        }
                    }
                } else {
                    setAvailable(false);
                    // Without this it would say "Available", which it technically is but it also can't be bought
                    switch (context.request.locale) {
                        //TODO move in resources
                        case 'it':
                            setAvailableLabel('NON DISPONIBILE');
                            break;
                        case 'en-GB':
                            setAvailableLabel('OUT OF STOCK');
                            break;
                        case 'en-US':
                            setAvailableLabel('OUT OF STOCK');
                            break;
                        case 'de':
                            setAvailableLabel('NICHT VERFÜGBAR');
                            break;
                        case 'fr':
                            setAvailableLabel('NON DISPONIBLE');
                            break;
                        default:
                            setAvailableLabel('OUT OF STOCK');
                            break;
                    }
                }
            })
            .catch(err => {
                console.error(err);
            });
        return;
    };

    React.useEffect(() => {
        void _isAvailable();
    }, [product]);

    //FINISHAVAILABILITY

    //GOOGLEANALTICS //TODO MOVE IN NEW DATALAYER CLASS

    const _ontoProductPDP = () => {
        trackProductTileClick(
            context,
            product as SimpleProduct,
            productCategoryUserPath ?? '',
            productListName ?? ''
        );

        //TODO OLD DATALAYER IMPLEMENTATION. AFTER SWITCHING TO V2, remove this one.
        const [list_name, category_name] = ['', ''];
        const productInfo = {
            name: product.Name,
            id: product.ItemId, //product SKU
            price: product.Price.toFixed(2),
            // 'dimension12': product.RecordId, //product ID (microsoft)
            list: list_name,
            category: category_name
        };
        window.dataLayer?.push?.({
            event: 'productClick',
            ecommerce: {
                // @ts-ignore
                currencyCode: window.___initialData___.requestContext.channel.Currency,
                click: {
                    actionField: { list: list_name },
                    products: [productInfo]
                }
            }
        });

        // setTimeout(() => {
        //     window.location.href = productUrl;
        // }, 0);
    };
    //FINISHGA FOR CLICK ON TILE

    //ADDTOCART
    //TODO MOVE THIS INTO NEW DATALAYER CLASS
    const _onAddSelectionToBag = async (event: React.MouseEvent): Promise<void> => {
        event?.stopPropagation();
        event?.preventDefault();
        //TODO CHANGE
        const [list_name, category_name] = ['', ''];
        var productInfo = {
            name: product.Name,
            id: product.ItemId, //product SKU
            price: product.Price.toFixed(2),
            quantity: 1,
            // 'dimension12': product.RecordId, //product ID (microsoft)
            category: category_name,
            list: list_name
        };
        //TODO restore way of saving list attribute
        // sessionStorage.setItem(product?.ItemId ?? '', category_name + ';' + list_name);

        window.dataLayer?.push?.({
            event: 'addToCart',
            ecommerce: {
                currencyCode: context.request.channel?.Currency,
                add: {
                    actionField: {
                        list: list_name,
                        action: 'add'
                    },
                    products: [productInfo]
                }
            }
        });

        // Also manage the removal from cart?

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- read config file.
        const addToCartBehavior = context.app.config.addToCartBehavior;
        const navigationUrl: string | undefined = getUrlSync('cart', context.actionContext);

        const catalogId = getCatalogId(context.actionContext.requestContext);

        const quantity: number = 1;

        trackAddToCartFromListing(
            context,
            product as SimpleProduct,
            productCategoryUserPath ?? '',
            productListName ?? ''
        )

        const cartState = await getCartState(context.actionContext);
        const addToCartResult = await cartState.addProductToCart({
            product: data.product as SimpleProduct,
            count: quantity,
            availableQuantity: undefined,
            additionalProperties: undefined,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- read config file.
            enableStockCheck: context.app.config.enableStockCheck,
            isPriceKeyedIn: undefined,
            customPrice: undefined,
            isAddEmailDeliveryItemToCart: undefined,
            shouldSkipSiteSettings: undefined,
            catalogId: catalogId
        });

        if (addToCartResult.status === 'SUCCESS') {
            if (addToCartBehavior === AddToCartBehavior.showModal) {
                // setDisabled(false);
            } else if (addToCartBehavior === AddToCartBehavior.showNotification) {
                // setDisabled(false);
                // const notification = new ItemSuccessfullyAddedToCartNotification(
                //     props.context,
                //     props.dialogStrings,
                //     props.imageSettings,
                //     undefined,
                //     product,
                //     data?.product?.Price,
                //     quantity,
                //     props.navigationUrl,
                //     undefined,
                //     props.id,
                //     props.typeName
                // );
                // NotificationsManager.instance().addNotification(notification);
            } else if (
                MsDyn365.isBrowser &&
                navigationUrl &&
                (addToCartBehavior === undefined || addToCartBehavior === AddToCartBehavior.goToCart)
            ) {
                window.location.assign(navigationUrl);
            } else {
                // setDisabled(false);
            }
            // propagateResult(props, addToCartResult);
        } else {
            // NotificationsManager.instance().addNotification(
            //     new ErrorNotification(
            //         addToCartResult.errorDetails?.LocalizedMessage ?? 'Add to cart failed',
            //         props.dialogStrings?.closeNotificationLabel ?? ''
            //     )
            // );
            // propagateError(props, { failureReason: 'CARTACTIONFAILED', cartActionResult: addToCartResult });
            // setDisabled(false);
        }
    };

    //FINISHADDTOCART

    //OMNIBUS //TODO move in price component

    let percent_discount = '';
    let discount_string = '';

    if (product.Price && product.BasePrice && product.BasePrice !== product.Price) {
        percent_discount = (100 - (product.Price / product.BasePrice) * 100).toFixed(0);
        discount_string = `-${percent_discount}%`;
    }

    const custom_basePrice = context.cultureFormatter.formatCurrency(product.BasePrice!.toFixed(2));
    const custom_adjustedPrice = context.cultureFormatter.formatCurrency(product.Price.toFixed(2));
    const omnibus_price = data.product?.AttributeValues?.filter(attribute => attribute.Name?.includes('Minimum Price Last 30 Days'));
    let omnibus_price_currency = '';
    if (omnibus_price !== undefined && omnibus_price?.length !== 0 && omnibus_price[0] !== undefined) {
        omnibus_price_currency = context.cultureFormatter.formatCurrency(omnibus_price[0].CurrencyValue!, omnibus_price[0].CurrencyCode);
    }

    let omnibus_string: React.ReactNode;
    switch (context.request.locale) {
        case 'it':
            omnibus_string = 'Prezzo più basso recente:';
            break;
        case 'en-GB':
            omnibus_string = 'Lowest recent price:';
            break;
        case 'en-us':
            omnibus_string = 'Lowest recent price:';
            break;
        case 'fr':
            omnibus_string = 'Prix le plus bas récemment:';
            break;
        case 'de':
            omnibus_string = 'niedrigster aktueller Preis:';
            break;
        default:
            omnibus_string = 'Lowest recent price:';
            break;
    }

    //FINISHOMNIBUS

    // Construct telemetry attribute to render
    const payLoad = getPayloadObject('click', telemetryContent!, '', product.RecordId.toString());

    const attribute = getTelemetryAttributes(telemetryContent!, payLoad);

    /**
     * Updates the product url link to product details page.
     * @param  productDetailsPageUrl - Product page url.
     * @param  coreContext - Context of the module using the component.
     * @param  queryString - Querystring to be added to the URL.
     * @returns The update product page url.
     */
    function updateProductUrl(productDetailsPageUrl: string, coreContext: ICoreContext, queryString: string): string {
        const sourceUrl = new URL(productDetailsPageUrl, coreContext.request.apiSettings.baseUrl);
        if (sourceUrl.search) {
            sourceUrl.search += `&${queryString}`;
        } else {
            sourceUrl.search += queryString;
        }

        const updatedUrl = new URL(sourceUrl.href);
        return updatedUrl.pathname + sourceUrl.search;
    }

    let productUrl = product ? getProductPageUrlSync(product.Name ?? '', product.RecordId, context.actionContext, undefined) : '';
    if (allowBack && productUrl) {
        productUrl = updateProductUrl(productUrl, context, 'back=true');
    }

    //MICROSOFT FUNCTIONS NOT USED FOR NOW

    // /**
    //  * Gets the product page url from the default swatch selected.
    //  * @param  productData - Product card to be rendered.
    //  * @returns The default swatch selected if any.
    //  */
    // function getDefaultSwatchSelected(productData?: ProductSearchResult): AttributeSwatch | null {
    //     if (!productData || !productData.AttributeValues) {
    //         return null;
    //     }

    //     const attributeSwatches = productData.AttributeValues.find(
    //         attributeValue => attributeValue.KeyName?.toLocaleLowerCase() === dimensionToPreSelectInProductCard
    //     )?.Swatches;

    //     if (!ArrayExtensions.hasElements(attributeSwatches)) {
    //         return null;
    //     }

    //     const defaultSwatch = attributeSwatches.find(item => item.IsDefault === true) ?? attributeSwatches[0];
    //     return defaultSwatch;
    // }

    // /**
    //  * Gets the product image from the default swatch selected.
    //  * @param  coreContext - Context of the module using the component.
    //  * @param  productData - Product card to be rendered.
    //  * @returns The product card image url.
    //  */
    // function getProductImageUrlFromDefaultSwatch(coreContext: ICoreContext, productData?: ProductSearchResult): string | undefined {
    //     const defaultSwatch = getDefaultSwatchSelected(productData);
    //     const swatchProductImageUrls = defaultSwatch?.ProductImageUrls;
    //     if (!ArrayExtensions.hasElements(swatchProductImageUrls)) {
    //         return productData?.PrimaryImageUrl;
    //     }

    //     return generateImageUrl(swatchProductImageUrls[0], coreContext.request.apiSettings);
    // }

    // /**
    //  * Gets the product page url from the default swatch selected.
    //  * @param  coreContext - Context of the module using the component.
    //  * @param productUrl - Product page url for the product card.
    //  * @param  productData - Product card to be rendered.
    //  * @returns The product card image url.
    //  */
    // function getProductPageUrlFromDefaultSwatch(
    //     coreContext: ICoreContext,
    //     productUrl: string,
    //     productData?: ProductSearchResult
    // ): string | undefined {
    //     const defaultSwatch = getDefaultSwatchSelected(productData);
    //     if (!defaultSwatch?.SwatchValue) {
    //         return productUrl;
    //     }

    //     const queryStringEncoded = encodeURIComponent(defaultSwatch.SwatchValue);
    //     const queryString = `${dimensionToPreSelectInProductCard}=${queryStringEncoded}`;
    //     return updateProductUrl(productUrl, coreContext, queryString);
    // }

    // const productImageUrlFromSwatch = getProductImageUrlFromDefaultSwatch(context, product) ?? product?.PrimaryImageUrl;
    // const productPageUrlFromSwatch = getProductPageUrlFromDefaultSwatch(context, productUrl, product) ?? productUrl;

    // const [productPageUrl, setProductPageUrl] = useState<string>(productPageUrlFromSwatch);
    // const [productImageUrl, setProductImageUrl] = useState<string | undefined>(productImageUrlFromSwatch);
    // const [selectedSwatchItems] = useState(new Dictionary<DimensionTypes, ISwatchItem>());
    // // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access -- app context is generic
    // const enableStockCheck = context.app.config.enableStockCheck;

    // /**
    //  * Updates the product page and Image url based on swatch selected.
    //  * @param coreContext - Context of the caller.
    //  * @param swatchItem - Dimension swatch selected.
    //  */
    // const updatePageAndImageUrl = React.useCallback(
    //     (coreContext: ICoreContext, swatchItem: ISwatchItem) => {
    //         const dimensionType = swatchItem.dimensionType;
    //         selectedSwatchItems.setValue(dimensionType, swatchItem);
    //         if (StringExtensions.isNullOrWhitespace(swatchItem.value)) {
    //             return;
    //         }
    //         const queryString = `${dimensionType}=${swatchItem.value}`;
    //         let productPageUrlWithSwatch = '';
    //         if (productPageUrl.includes(dimensionType)) {
    //             const newUrl = new URL(productPageUrl, coreContext.request.apiSettings.baseUrl);
    //             newUrl.searchParams.delete(dimensionType);
    //             productPageUrlWithSwatch = updateProductUrl(newUrl.toString(), context, queryString);
    //         } else {
    //             productPageUrlWithSwatch = updateProductUrl(productPageUrl, context, queryString);
    //         }
    //         setProductPageUrl(productPageUrlWithSwatch);
    //         if (dimensionType === dimensionToPreSelectInProductCard) {
    //             const swatchProductImageUrl = ArrayExtensions.hasElements(swatchItem.productImageUrls)
    //                 ? swatchItem.productImageUrls[0]
    //                 : undefined;
    //             const newImageUrl = generateImageUrl(swatchProductImageUrl, coreContext.request.apiSettings);
    //             setProductImageUrl(newImageUrl);
    //         }
    //     },
    //     [selectedSwatchItems, context, productPageUrl]
    // );

    // const swatchItems = ArrayExtensions.validValues(
    //     product.AttributeValues?.map(item => {
    //         const dimensionTypeValue = item.KeyName?.toLocaleLowerCase() ?? '';
    //         const shouldDisplayAsSwatch = checkIfShouldDisplayAsSwatch(
    //             dimensionTypeValue as DimensionTypes,
    //             context as ICoreContext<IDimensionsApp>,
    //             DimensionSwatchDisplayTypes.productCard
    //         );
    //         if (!shouldDisplayAsSwatch) {
    //             return null;
    //         }

    //         const dimensionType = dimensionTypeValue as DimensionTypes;
    //         const swatches =
    //             item.Swatches?.map<ISwatchItem>(swatchItem => {
    //                 return {
    //                     itemId: `${item.RecordId ?? ''}-${dimensionTypeValue}-${swatchItem.SwatchValue ?? ''}`,
    //                     value: swatchItem.SwatchValue ?? '',
    //                     dimensionType,
    //                     colorHexCode: swatchItem.SwatchColorHexCode,
    //                     imageUrl: swatchItem.SwatchImageUrl,
    //                     productImageUrls: swatchItem.ProductImageUrls,
    //                     isDefault: swatchItem.IsDefault,
    //                     swatchItemAriaLabel: swatchItemAriaLabel ? format(swatchItemAriaLabel, dimensionType) : '',
    //                     isDisabled:
    //                         enableStockCheck &&
    //                         dimensionAvailabilities?.find(
    //                             dimensionAvailability => dimensionAvailability.value === (swatchItem.SwatchValue ?? '')
    //                         )?.isDisabled
    //                 };
    //             }) ?? [];
    //         if (
    //             dimensionType === dimensionToPreSelectInProductCard &&
    //             ArrayExtensions.hasElements(swatches) &&
    //             !swatches.some(swatch => swatch.isDefault)
    //         ) {
    //             swatches[0].isDefault = true;
    //         }
    //         return { recordId: item.RecordId, swatches };
    //     })
    // );

    //ORIGINAL MICROSOFT FUNCTIONS NOT USED FOR NOW

    // // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- -- Do not need type check for appsettings
    // const isUnitOfMeasureEnabled = context.app.config && context.app.config.unitOfMeasureDisplayType === 'buyboxAndBrowse';

    // /**
    //  * Gets the react node for product unit of measure display.
    //  * @param  unitOfMeasure - DefaultUnitOfMeasure property from product.
    //  * @returns The node representing markup for unit of measure component.
    //  */
    // function renderProductUnitOfMeasure(unitOfMeasure?: string): JSX.Element | null {
    //     if (!unitOfMeasure) {
    //         return null;
    //     }
    //     return (
    //         <div className='msc-product__unit-of-measure'>
    //             <span>{unitOfMeasure}</span>
    //         </div>
    //     );
    // }

    // /**
    //  * Gets the react node for product availability.
    //  * @param inventoryAvailabilityLabel - The product information.
    //  * @returns The node representing markup for product availability.
    //  */
    // function renderProductAvailability(inventoryAvailabilityLabel: string | undefined): JSX.Element | null {
    //     if (!inventoryAvailabilityLabel || inventoryAvailabilityLabel === '') {
    //         return null;
    //     }

    //     return (
    //         <div className='msc-product__availability'>
    //             <span>{inventoryAvailabilityLabel}</span>
    //         </div>
    //     );
    // }

    // /**
    //  * Gets the react node for product dimension as swatch.
    //  * @returns The node representing markup for unit of measure component.
    //  */
    // function renderProductDimensions(): JSX.Element | null {
    //     if (!ArrayExtensions.hasElements(swatchItems)) {
    //         return null;
    //     }

    //     return (
    //         <div className='msc-product__dimensions'>
    //             {swatchItems.map(item => {
    //                 return (
    //                     <ProductComponentSwatchComponent
    //                         key={item.recordId}
    //                         context={context}
    //                         onSelectDimension={updatePageAndImageUrl}
    //                         swatches={item.swatches}
    //                     />
    //                 );
    //             })}
    //         </div>
    //     );
    // }

    // /**
    //  * Gets the react node for  product description.
    //  * @param  quickview - Quick view node.
    //  * @param  item - Product id to de displayed in quickview.
    //  * @returns The product quickview component.
    //  */
    // function renderQuickView(quickview: React.ReactNode, item?: number): JSX.Element | undefined {
    //     if (quickview === null) {
    //         return undefined;
    //     }
    //     const selectedDimensions: ProductDimension[] = selectedSwatchItems.getValues().map<ProductDimension>(swatches => {
    //         return {
    //             DimensionTypeValue: convertDimensionTypeToProductDimensionType(swatches.dimensionType),
    //             DimensionValue: {
    //                 RecordId: 0,
    //                 Value: swatches.value
    //             }
    //         };
    //     });
    //     return React.cloneElement(quickview as React.ReactElement, { selectedProductId: item, selectedDimensions });
    // }

    /**
     * Gets the aria label for rating.
     * @param  rating - Product rating.
     * @param  ratingAriaLabelText - Aria label format for rating.
     * @returns The product rating aria label string.
     */
    function getRatingAriaLabel(rating?: number, ratingAriaLabelText?: string): string {
        if (rating && ratingAriaLabelText) {
            const roundedRating = rating.toFixed(2);
            return format(ratingAriaLabelText || '', roundedRating, '5');
        }
        return '';
    }

    /**
     * Gets the aria label for review count.
     * @param  reviewCount - Product review count.
     * @param  ratingCountAriaLabelText - Aria label format for review.
     * @returns The product review count aria label string.
     */
    function getReviewAriaLabel(reviewCount?: number, ratingCountAriaLabelText?: string): string {
        if (reviewCount && ratingCountAriaLabelText) {
            return format(ratingCountAriaLabelText || '', reviewCount);
        }
        return '';
    }

    /**
     * Gets the aria label string for product that includes product name with its price and rating.
     * @param  name - Product name.
     * @param  price - Product price.
     * @param  rating - Product rating.
     * @param  ratingAriaLabelText - Rating aria label text.
     * @param  reviewCount - Product review count.
     * @param  ratingCountAriaLabelText - Number of ratings.
     * @returns The aria label string for the product card.
     */
    function renderLabel(
        name?: string,
        price?: string,
        rating?: number,
        ratingAriaLabelText?: string,
        reviewCount?: number,
        ratingCountAriaLabelText?: string,
        availability?: string
    ): string {
        const reviewCountArialableText = getReviewAriaLabel(reviewCount, ratingCountAriaLabelText ?? '');
        return `${name ?? ''} ${price ?? ''} ${getRatingAriaLabel(rating, ratingAriaLabelText)}${
            reviewCountArialableText ? ` ${reviewCountArialableText}` : ''
        } ${availability ?? ''}`;
    }

    /**
     * Gets the react component for product rating.
     * @param  productCardimageSettings - Module image settings for product card.
     * @param  gridSettings - Grid settings defined in theme.
     * @param  imageUrl - Image url.
     * @param fallbackImageUrl - Fallback url for imge.
     * @param  altText - Image Alt text.
     * @param  requestContext - Request context using the component.
     * @returns React component for product image.
     */
    function renderProductPlacementImage(
        productCardimageSettings?: IImageSettings,
        gridSettings?: IGridSettings,
        imageUrl?: string,
        fallbackImageUrl?: string,
        altText?: string,
        requestContext?: IRequestContext
    ): JSX.Element | null {
        if (!imageUrl || !gridSettings || !productCardimageSettings) {
            return null;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Site level config can be of any type.
        const emptyPlaceHolderImage = context.app.config.placeholderImageName as string;
        let fallbackImageSource = fallbackImageUrl;
        if (emptyPlaceHolderImage && fallbackImageUrl) {
            fallbackImageSource = `${fallbackImageUrl},${emptyPlaceHolderImage}`;
        }
        const image: IImageData = {
            src: imageUrl,
            altText: altText ? altText : '',
            fallBackSrc: fallbackImageSource
        };
        const imageProps: IImageProps = { gridSettings };

        imageProps.gridSettings = gridSettings;
        imageProps.imageSettings = productCardimageSettings;
        imageProps.imageSettings.cropFocalRegion = true;
        return <Image {...image} {...imageProps} loadFailureBehavior='empty' requestContext={requestContext} bypassHideOnFailure />;
    }

    /**
     * Gets the react component for product rating.
     * @param  coreContext - Context of the module using the component.
     * @param  moduleTypeName - Module type name.
     * @param  moduleId - Module id using the component.
     * @param  productSearchResult - Product search result.
     * @param  savingsPriceResourceText - Product price saving text.
     * @param  freePriceResourceText - Product price free text.
     * @param  originalPriceResourceText - Product price original text.
     * @param  currentPriceResourceText - Product price current text.
     * @returns React component for Product price.
     */
    function renderPrice(
        coreContext: ICoreContext,
        moduleTypeName: string,
        moduleId: string,
        productSearchResult: ProductSearchResult,
        savingsPriceResourceText?: string,
        freePriceResourceText?: string,
        originalPriceResourceText?: string,
        currentPriceResourceText?: string
    ): JSX.Element {
        const product: SimpleProduct = {
            // This is a fake product. The product type is only used for price component to determine if it should show price range or not.
            ProductTypeValue: productSearchResult.IsMasterProduct ? ProductType.Master : ProductType.Standalone
        } as SimpleProduct;

        const price: ProductPrice = {
            BasePrice: productSearchResult.BasePrice,
            AdjustedPrice: productSearchResult.Price,
            CustomerContextualPrice: productSearchResult.Price,
            // TODO from [gaweiche]: We should not put productSearchResult.Price into min/max price.
            // To minimize the change in a backport PR, I'll keep it as is for now.
            MaxVariantPrice: productSearchResult.MaxVariantPrice ? productSearchResult.MaxVariantPrice : productSearchResult.Price,
            MinVariantPrice: productSearchResult.MinVariantPrice ? productSearchResult.MinVariantPrice : productSearchResult.Price
        } as ProductPrice;

        return (
            <div className='price-row'>
                <PriceComponent
                    context={coreContext}
                    id={moduleId}
                    typeName={moduleTypeName}
                    product={product}
                    data={{ price }}
                    savingsText={savingsPriceResourceText}
                    freePriceText={freePriceResourceText}
                    originalPriceText={originalPriceResourceText}
                    currentPriceText={currentPriceResourceText}
                    isPriceMinMaxEnabled={isPriceMinMaxEnabled}
                    priceResources={priceResources}
                />
            </div>
        );
    }

    // /**
    //  * Gets the react node for product description.
    //  * @param  description - Product description.
    //  * @returns The product description component.
    //  */
    // function renderDescription(description?: string): JSX.Element | null {
    //     return <p className='msc-product__text'>{description}</p>;
    // }

    // /**
    //  * Gets the react component for product rating.
    //  * @param  coreContext - Context of the module using the component.
    //  * @param  moduleTypeName - Module type name.
    //  * @param  moduleId - Module id using the component.
    //  * @param  avgRating - Average rating.
    //  * @param  totalRatings - Total rating.
    //  * @param  ariaLabel - Aria label for rating.
    //  * @returns React component for Product rating.
    //  */
    // function renderRating(
    //     coreContext: ICoreContext,
    //     moduleTypeName: string,
    //     moduleId: string,
    //     avgRating?: number,
    //     totalRatings?: number,
    //     ariaLabel?: string
    // ): JSX.Element | null {
    //     if (!avgRating) {
    //         return null;
    //     }

    //     const numberRatings = totalRatings?.toString() || undefined;
    //     const ratingAriaLabelText = getRatingAriaLabel(avgRating, ariaLabel);
    //     const ratingCountAriaLabelText = getReviewAriaLabel(Number(numberRatings), ratingCountAriaLabel);

    //     return (
    //         <RatingComponent
    //             context={coreContext}
    //             id={moduleId}
    //             typeName={moduleTypeName}
    //             avgRating={avgRating}
    //             ratingCount={numberRatings}
    //             readOnly
    //             ariaLabel={ratingAriaLabelText}
    //             ratingCountAriaLabel={ratingCountAriaLabelText}
    //             data={{}}
    //         />
    //     );
    // }

    //PICK&MIX

    if (catPage === 'pick-mix') {
        // @ts-ignore
        const searchContainerResaurces = context?.actionContext?.requestCache?.internalCache?.__MR['SEARCH-RESULT-CONTAINER']?.item;
        // @ts-ignore
        const pmProducts = context.pmProducts;
        const RecordId = product.RecordId;
        const initialQuntity = pmProducts && pmProducts[RecordId] && pmProducts[RecordId].Qty;
        const [add, setAdd] = React.useState(initialQuntity > 0 && initialQuntity !== undefined ? false : true);

        const [quantity, setQuantity] = React.useState(initialQuntity > 0 && initialQuntity !== undefined ? initialQuntity : 0);

        const removedFromCart = () => {
            const localPm = localStorage && localStorage.getItem('pm_products');
            const localPmProds = localPm && localPm !== null ? localPm : JSON.stringify({});
            const pmProductsList = JSON.parse(localPmProds);
            if (pmProductsList[product.RecordId] === undefined) {
                setQuantity(0);
                setAdd(true);
            }
        };
        const cookiePMset = typeof window !== 'undefined' ? localStorage.setItem('pm_products', JSON.stringify(pmProducts)) : undefined;
        React.useEffect(() => {
            const wrapper = document.getElementsByClassName('pm-cart--ctn')[0];

            // tslint:disable-next-line:typedef no-any
            function handleButtonClick(event: any) {
                const isButton = event.target.nodeName === 'BUTTON';

                if (!isButton) {
                    return;
                }
                const timer = setTimeout(() => {
                    removedFromCart();
                }, 100);
                return () => {
                    clearTimeout(timer);
                };
            }

            wrapper.addEventListener('click', handleButtonClick);
            return () => wrapper.removeEventListener('click', handleButtonClick);
        });

        function plusOneProductToPmCart(pRecordId: number): void {
            // @ts-ignore
            const pmProductsList = context.pmProducts;
            const productQuantity = Number(pmProductsList[pRecordId]?.Qty) + 1;
            if (pmProductsList[pRecordId] !== undefined) {
                pmProductsList[pRecordId].Qty = productQuantity;
                cookiePMset;
                setQuantity(productQuantity);
            } else {
                return;
            }
        }

        function removeOneProductFromPmCart(pRecordId: number): void {
            // @ts-ignore
            const pmProductsList = context.pmProducts;
            const productQuantity = Number(pmProductsList[pRecordId]?.Qty) - 1;

            if (productQuantity >= 0) {
                pmProductsList[pRecordId].Qty = productQuantity;
                cookiePMset;
                setQuantity(productQuantity);
            }
            if (productQuantity === 0) {
                delete pmProductsList[pRecordId];
                cookiePMset;
                setAdd(true);
            }
        }

        function addProductToPmCart(
            pRecordId: number,
            Name: string | undefined,
            Description: string | undefined,
            PrimaryImageUrl: string | undefined,
            pQuantity: number,
            Price: number
        ): void {
            // @ts-ignore
            const pmProductsList = context.pmProducts;
            setAdd(false);
            pmProductsList[pRecordId] = {
                Id: pRecordId,
                Item: Name,
                Qty: pQuantity,
                UOM: '',
                Price: Price,
                Description: Description,
                DataAreaId: '',
                PrimaryImageUrl: PrimaryImageUrl
            };
            // @ts-ignore
            context.pmProducts = pmProductsList;
            cookiePMset;
            setQuantity(1);
        }

        // @ts-ignore
        const AddToCartButtons = ({ showadd }) => {
            if (showadd) {
                return (
                    <>
                        {/* tslint:disable-next-line:jsx-no-lambda react-this-binding-issue */}
                        <button
                            className={'border-button add-to-mix-cart'}
                            onClick={() =>
                                addProductToPmCart(
                                    product.RecordId,
                                    product.Name,
                                    product.ItemId,
                                    product.PrimaryImageUrl,
                                    1,
                                    product.Price
                                )
                            }
                        >
                            {searchContainerResaurces.addText}
                        </button>
                    </>
                );
            }

            return (
                <>
                    {/* tslint:disable-next-line:jsx-no-lambda react-this-binding-issue */}
                    <button
                        onClick={() => removeOneProductFromPmCart(product.RecordId)}
                        title='Press to decrease the quantity by 1'
                        className='decrement quantity__controls'
                        aria-hidden='true'
                        aria-label='Press to decrease the quantity by 1'
                        color='secondary'
                    />
                    {/* tslint:disable-next-line:max-line-length */}
                    <input
                        type='number'
                        className='quantity-input'
                        pattern='[0-9]*'
                        value={quantity}
                        aria-live='polite'
                        aria-label='quantity input'
                        role='spinbutton'
                        aria-valuemin={valuemin}
                        aria-valuemax={valuemax}
                        aria-valuenow={quantity}
                        readOnly
                    />
                    {/* tslint:disable-next-line:jsx-no-lambda react-this-binding-issue max-line-length */}
                    <button
                        onClick={() => plusOneProductToPmCart(product.RecordId)}
                        title='Press to increment quantity by 1'
                        className='increment quantity__controls '
                        aria-hidden='true'
                        aria-label='Press to increment quantity by 1'
                        color='secondary'
                    />
                </>
            );
        };
        // @ts-ignore
        return (
            <div className={'msc-product__mix-item'}>
                <div className='msc-product__image'>
                    {renderProductPlacementImage(
                        imageSettings,
                        context.request.gridSettings,
                        product.PrimaryImageUrl,
                        product.PrimaryImageUrl,
                        product.Name,
                        context.actionContext.requestContext
                    )}
                </div>
                <div className='msc-product__details__pm'>
                    <h4 className='msc-product__title'>{product.Name}</h4>
                    {renderModalPopup}
                    {/* tslint:disable-next-line:max-line-length jsx-no-lambda react-this-binding-issue react-a11y-event-has-role */}
                    {
                        <a
                            onClick={() => setModalOpen(true)}
                            aria-label={renderLabel(
                                product.Name,
                                context.cultureFormatter.formatCurrency(product.Price),
                                product.AverageRating,
                                ratingAriaLabel
                            )}
                            className='hyperlink view_details '
                            {...attribute}
                        >
                            {searchContainerResaurces.viewDetailsText}
                        </a>
                    }
                    <p className='msc-product__text'>{product.Description}</p>
                    {renderPrice(context, typeName, id, product, savingsText, freePriceText, originalPriceText, currentPriceText)}
                    <div className='quantity'>
                        <AddToCartButtons showadd={add} />
                    </div>
                    <div className='msc-product__extra-data'>
                        <span className='data-product-id'>{product.RecordId}</span>
                        <span className='data-product-sku'>{product.ItemId}</span>
                    </div>
                </div>
            </div>
        );
    }

    //FINISHPICKMIX

    // console.log("category");
    // console.log(productCategoryUserPath);
    //STDPRODUCT
    return (
        <>
            <a
                // href={productPageUrl}
                href={productUrl}
                onClick={() => {
                    _ontoProductPDP();
                    onTelemetryClick(telemetryContent!, payLoad, product.Name!);
                }}
                aria-label={renderLabel(
                    product.Name,
                    context.cultureFormatter.formatCurrency(product.Price),
                    product.AverageRating,
                    ratingAriaLabel
                    // product.TotalRatings,
                    // ratingCountAriaLabel,
                    // inventoryLabel
                )}
                className={`msc-product status_${available ? 'AVAL' : 'OOS'}`}
                {...attribute}
            >
                <div className='msc-product__features'>
                    <div className='msc-product__image'>
                        {renderProductPlacementImage(
                            imageSettings,
                            context.request.gridSettings,
                            product.PrimaryImageUrl,
                            product.PrimaryImageUrl,
                            product.Name,
                            context.actionContext.requestContext
                        )}
                    </div>
                    <div className='msc-product__details container'>
                        <div className='row title-row'>
                            <h4 className='msc-product__title'>{product.Name}</h4>
                        </div>
                        <div className='msc-product__text row'>
                            <p className='msc-product__text'>{product.Description}</p>
                        </div>
                        <div className='msc-product__extra-data'>
                            {/*
                                //TODO restore way of saving list attribute
                                <span className='card-guid'>{card_guid}</span>
                            */}
                            <span className='data-product-id'>{product.RecordId}</span>
                            <span className='data-product-sku'>{product.ItemId}</span>
                        </div>
                        {/* {!context.app.config.hideRating && (
                                renderRating(context, typeName, id, product.AverageRating, product.TotalRatings, ratingAriaLabel)
                            )} */}
                        {product.BasePrice !== product.Price && (
                            <span className='msc-price-discounted'>
                                <span className='msc-price-discounted-mobile'>
                                    <span className='msc-price-discounted__strikethrough'>{custom_basePrice}</span>
                                    <span className='msc-price-discounted__percent-discount'>{discount_string}</span>
                                </span>
                            </span>
                        )}
                    </div>
                </div>
                {product.BasePrice !== 0 ? (
                    <div className='msc-product__aligned-price'>
                        {product.BasePrice === product.Price ? (
                            <>
                                <span className='msc-price'>
                                    <span className='msc-price__actual'>{custom_basePrice}</span>
                                </span>

                                {/* THE FOLLOWING IS SHOWN FOR SPACING REASONS */}
                                <span className='msc-price-discounted__recent-price'>&nbsp;</span>
                                {/* DO NOT REMOVE THIS */}
                            </>
                        ) : (
                            <>
                                <span className='msc-price-discounted'>
                                    <span className='msc-price-discounted__actual-post-discount'>{custom_adjustedPrice}</span>
                                </span>
                                <span className='msc-price-discounted__recent-price'>
                                    {omnibus_price_currency ? (
                                        <>
                                            {omnibus_string}&nbsp;
                                            <span style={{ textDecoration: 'line-through' }}>{omnibus_price_currency}</span>
                                        </>
                                    ) : (
                                        <>&nbsp;</>
                                    )}
                                </span>
                            </>
                        )}
                        {/* <div className='msc-product__min-height-avail-row'> */}
                        <div className={`${!available ? 'ms-buybox__inventory-info' : ''} msc-product__avail-row`}>
                            {available ? (
                                <button
                                    className='msc-add-to-cart'
                                    onClick={_onAddSelectionToBag}
                                    style={{ visibility: loading ? 'hidden' : 'visible' }}
                                >
                                    {/* <button className='solid-button msc-add-to-cart' onClick={_onAddSelectionToBag} style={{ visibility: loading ? 'hidden' : 'visible'}}> */}
                                    {/* {cart_string} */}
                                    { resources?.addToCartText}
                                </button>
                            ) : (
                                <span className='ms-buybox__inventory-label ms-buybox__inventory-code-oos'>{availableLabel}</span>
                            )}
                        </div>
                        {/* </div> */}
                    </div>
                ) : null}
            </a>

            {/*MICROSOFTCODE
                <div className='msc-product__image'>
                    {renderProductPlacementImage(
                        imageSettings,
                        context.request.gridSettings,
                        productImageUrl,
                        product.PrimaryImageUrl,
                        product.Name,
                        context.actionContext.requestContext
                    )}
                </div>
                <h4 className='msc-product__title'>{product.Name}</h4>
            </a>
            {renderProductDimensions()}
            <div className='msc-product__details'>
                {renderPrice(context, typeName, id, product, savingsText, freePriceText, originalPriceText, currentPriceText)}
                {isUnitOfMeasureEnabled && renderProductUnitOfMeasure(product.DefaultUnitOfMeasure)}
                {renderDescription(product.Description)}
                {!context.app.config.hideRating &&
                    renderRating(context, typeName, id, product.AverageRating, product.TotalRatings, ratingAriaLabel)}
                {renderProductAvailability(inventoryLabel)}
            </div>
            {quickViewButton && renderQuickView(quickViewButton, product.RecordId)}
            {productComparisonButton && renderProductComparisonButton(productComparisonButton, product, getCatalogId(context.request))} */}
        </>
    );
};

export const ProductComponent: React.FunctionComponent<IProductComponentProps> = msdyn365Commerce.createComponentOverride<
    IProductComponent
>('Product', { component: ProductCard, ...PriceComponentActions });

export default ProductComponent;
